import React from 'react'
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
function Pagenation() {
  return (
    <div className="pagenation">
      <a href="fff">1</a>
      <a href="ffff"> 2</a>
      <a href="#ggg">
        <ArrowForwardIosIcon />
      </a>
    </div>
  );
}

export default Pagenation